var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.136 7.481a3.137 3.137 0 10-3.135 3.136v1.343l-.232-.005A4.48 4.48 0 015.526 7.71l-.006-.23A4.48 4.48 0 0110 3.001l.231.005a4.48 4.48 0 014.249 4.475l-.006.23a4.48 4.48 0 01-4.473 4.25v-1.344a3.136 3.136 0 003.135-3.136z",
    fill: "#4E5969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.409 12.23c-1.17-1.05-2.749-1.502-4.41-1.502-1.66 0-3.237.451-4.408 1.502C4.41 13.292 3.728 14.89 3.728 17h1.344c0-1.81.573-3.012 1.417-3.77.856-.77 2.079-1.158 3.51-1.158 1.432 0 2.655.389 3.511 1.158l.899-1z",
    fill: "#4E5969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5l1.618 1.618a.5.5 0 00.733-.028L15.5 13",
    stroke: "#4E5969",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
export default SvgTodoIcon;